import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOut } from 'components/sharpr/util/spliceOut.js';

let state = {
	isExpanded: true,
	hasLinks: false,
	isIntelTab: false,
	list: [],
};

export function PartnerLinksResolves(resolves) {
	resolves.__partnerLinks = ApiResourcify.endpoint('/partner_links?tz=' + new Date().getTimezoneOffset(), {
		withResponse: resp => {
			state.list = resp.data;
			state.hasLinks = state.list && state.list.length > 0;
		},
		cacheFor: 30 * 60 * 1000,
	});
}

export class PartnerLinksService {
	constructor(Api, $state, $rootScope) {
		'ngInject';
		this.Api = Api;
		$rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
			state.isIntelTab = toState.name == 'hub.loggedin.PostListing';
			this.notifySubscribers();
		});
		state.isIntelTab = $state.current.name == 'hub.loggedin.PostListing';
		this.subscribers = [];
	}

	refreshLinks() {
		return this.Api.get('/partner_links', { tz: new Date().getTimezoneOffset() }).then(data => {
			state.list = data;
			state.hasLinks = data.length > 0;
			this.notifySubscribers();
		});
	}

	clear() {
		state.list = [];
		state.hasLinks = false;
		this.notifySubscribers();
	}

	onStateChange(handler) {
		this.subscribers.push(handler);
		handler(state);
	}

	offStateChange(handler) {
		spliceOut(this.subscribers, handler);
	}

	notifySubscribers() {
		this.subscribers.forEach(handler => handler(state));
	}

	toggleExpanded() {
		state.isExpanded = !state.isExpanded;
		this.notifySubscribers();
	}
}
